import React from 'react';
import { Branding, Copyright } from './Layout';
import PastEvents from './PastEvents';

const FutureEvents = ({ participant, futureEvents, handleLogout, onEditProfile, onSelectEvent, pastParticipations, onRevealMatches, onShowMatches }) => {
    const isAdminUser = Number(participant.UserId || participant.id) === 1;

    return (
        <div className="mx-auto w-100" style={{ maxWidth: '800px' }}>
            <div className="card glass-premium border-0 p-4 p-md-5 mb-4 fade-in-up shadow-lg mx-2 position-relative" style={{ borderRadius: '45px', overflow: 'visible' }}>
                <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center align-items-sm-start gap-4 mb-5">
                    <div className="d-flex align-items-center gap-4">
                        <div className="position-relative">
                            <div
                                className="rounded-circle bg-white shadow-sm d-flex align-items-center justify-content-center overflow-hidden border border-light"
                                style={{ width: '80px', height: '80px' }}
                            >
                                {participant.photo ? (
                                    <img src={participant.photo} alt="Profile" className="w-100 h-100 object-fit-cover" />
                                ) : (
                                    <i className="fas fa-user fa-2x text-pink-600"></i>
                                )}
                            </div>
                            <button 
                                className="btn btn-white shadow-sm rounded-circle position-absolute border-0 d-flex align-items-center justify-content-center" 
                                onClick={onEditProfile} 
                                style={{ bottom: '-5px', right: '-5px', width: '32px', height: '32px', zIndex: 5, padding: 0 }}
                            >
                                <i className="fas fa-pencil-alt text-pink-600" style={{ fontSize: '0.8rem' }}></i>
                            </button>
                        </div>
                        <div>
                            <Branding />
                            <div className="mt-3">
                                <h5 className="text-pink-600 fw-900 ls-lg mb-1 small">BENVENUTO, {(participant?.firstName || 'Utente').toUpperCase()}</h5>
                                <div className="d-flex flex-wrap gap-2 mb-3 mt-2">
                                    <button className="btn btn-light btn-sm rounded-pill px-3 shadow-sm fw-900 d-flex align-items-center gap-2 border-0" onClick={handleLogout} style={{ fontSize: '0.7rem' }}>
                                        <i className="fas fa-sign-out-alt"></i> 
                                        <span>ESCI</span>
                                    </button>
                                    <button className="btn btn-white btn-sm rounded-pill px-3 shadow-sm fw-900 d-flex align-items-center gap-2 border-0 text-pink-600" onClick={onShowMatches} style={{ fontSize: '0.7rem' }}>
                                        <i className="fas fa-heart"></i> 
                                        <span>I MIEI MATCH</span>
                                    </button>
                                </div>
                                {futureEvents.length > 0 && (
                                    <h1 className="fw-900 text-dark mb-0" style={{ fontSize: '2rem' }}>Eventi Disponibili</h1>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {futureEvents.length === 0 ? (
                    <div className="text-center py-5">
                        <i className="fas fa-calendar-times fa-3x text-muted mb-3 opacity-20"></i>
                        <p className="text-muted fw-600">Non ci sono eventi in programma al momento. Torna a trovarci!</p>
                    </div>
                ) : (
                    <div className="row g-4">
                        {futureEvents.map((ev, idx) => {
                            const isReg = ev.isRegistered || Boolean(
                                (participant.EventId && Number(participant.EventId) === Number(ev.id)) ||
                                (participant.Participations && participant.Participations.some(p => Number(p.EventId) === Number(ev.id))) ||
                                (participant.participations && participant.participations.some(p => Number(p.EventId) === Number(ev.id)))
                            );
                            return (
                                <div className="col-12" key={idx}>
                                    <div className="card glass-premium rounded-5 transition-all overflow-hidden" style={{ background: isReg ? 'rgba(253, 242, 248, 0.9)' : 'rgba(255,255,255,0.9)', border: isReg ? '2px solid #db2777' : '1px solid rgba(219,39,119,0.1)' }}>
                                        {ev.coverImage && (
                                            <div style={{ height: '200px', width: '100%' }}>
                                                <img src={ev.coverImage} alt={ev.name} style={{ objectFit: 'cover' }} className="w-100 h-100" />
                                            </div>
                                        )}
                                        <div className="p-4">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div>
                                                    {isReg ? (
                                                        <span className="badge bg-success text-white mb-2 px-3 rounded-pill small me-2"><i className="fas fa-check me-1"></i> SEI ISCRITTO</span>
                                                    ) : (
                                                        <span className="badge bg-pink-600 text-white mb-2 px-3 rounded-pill small">NUOVO EVENTO</span>
                                                    )}
                                                    <h3 className="fw-900 text-dark mb-1">{ev.name}</h3>
                                                    <div className="text-muted fw-600 small">
                                                        <i className="fas fa-calendar-day me-2"></i> {new Date(ev.date).toLocaleDateString('it-IT', { weekday: 'long', day: 'numeric', month: 'long' })}
                                                        <i className="fas fa-map-marker-alt ms-3 me-2"></i> {ev.city?.name}
                                                    </div>
                                                </div>
                                                <div className="text-end">
                                                    <button
                                                        onClick={() => onSelectEvent(ev)}
                                                        className={`btn rounded-pill px-4 fw-900 shadow-sm border-0 ${isReg ? 'btn-light text-pink-600' : 'btn-danger text-white'}`}
                                                        style={{ background: isReg ? '#f8f9fa' : 'linear-gradient(45deg, #db2777, #f43f5e)', border: isReg ? '1px solid #db2777 !important' : 'none' }}
                                                    >
                                                        {isReg ? 'AGGIUNGI AMICI' : 'ISCRIVITI'}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
            <PastEvents participations={pastParticipations} onRevealMatches={onRevealMatches} />
            <Copyright />
        </div>
    );
};

export default FutureEvents;
